import * as React from 'react';
import { useTabs } from './Tabs';
import { classNames } from '../../../utils';

export interface ITabProps {
  label: string;
  className?: string;
  theme?: TabTheme;
  component?: (onClick: () => void) => React.ReactNode;
  children?: React.ReactNode;
}

export enum TabTheme {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export type TabThemeOpts = {
  active: string;
  nonActive: string;
  base: string;
};

const TAB_MAPPER: Record<TabTheme, TabThemeOpts> = {
  PRIMARY: {
    active: 'bg-white',
    base: 'flex h-14 flex-1',
    nonActive: 'bg-gray-lightest',
  },
  SECONDARY: {
    active: 'bg-gray-lightest',
    base: 'flex h-14 flex-1',
    nonActive: 'bg-white text-gray-light',
  },
};

export function Tab({
  label,
  children,
  className,
  component,
  theme = TabTheme.PRIMARY,
}: ITabProps) {
  const { activeTab, setActiveTab } = useTabs();
  const handleOnClick = React.useCallback(() => {
    setActiveTab(label);
  }, [label, setActiveTab]);

  return component ? (
    <>{component(handleOnClick)}</>
  ) : (
    <div
      className={classNames(
        className
          ? className
          : `${TAB_MAPPER[theme].base} ${
              activeTab === label
                ? TAB_MAPPER[theme].active
                : TAB_MAPPER[theme].nonActive
            }`,
      )}
    >
      <button
        className={`w-full py-4 text-base font-semibold tracking-tight focus:outline-none`}
        onClick={() => setActiveTab(label)}
      >
        {children}
      </button>
    </div>
  );
}
